function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg123Reg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 34,
    viewBox: "0 0 162 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo-123Reg-Contrast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M37.65,34h30.1a1.91,1.91,0,0,0,2-1.86V1.86a1.91,1.91,0,0,0-2-1.86H37.65A1.91,1.91,0,0,0,35.7,1.86V32.14A1.91,1.91,0,0,0,37.65,34",
    style: {
      fill: "#1990d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35,34h30.1a1.91,1.91,0,0,0,2-1.86V1.86a1.91,1.91,0,0,0-2-1.86H73.35A1.91,1.91,0,0,0,71.4,1.86V32.14A1.91,1.91,0,0,0,73.35,34",
    style: {
      fill: "#7eb828",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,34h30.1a1.91,1.91,0,0,0,2-1.86V1.86a1.91,1.91,0,0,0-2-1.86H2A1.91,1.91,0,0,0,0,1.86V32.14A1.91,1.91,0,0,0,2,34",
    style: {
      fill: "#e1144d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.86,27.2h2.88a.49.49,0,0,0,.48-.5V7.3a.49.49,0,0,0-.48-.5H14.26a.49.49,0,0,0-.48.5V9.85a.49.49,0,0,0,.48.51h1.63a.49.49,0,0,1,.48.5V26.7a.5.5,0,0,0,.49.5",
    style: {
      fill: "#fefefe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.93,27.2H59.47a.48.48,0,0,0,.49-.49V24.13a.48.48,0,0,0-.49-.49H52a.49.49,0,0,1-.33-.85l3.67-3.27c2.44-2.17,4.16-3.9,4.16-6.33,0-3.76-2.88-6.39-7-6.39-3.9,0-6.69,2.41-7,6a.49.49,0,0,0,.49.54h3a.5.5,0,0,0,.49-.43,2.86,2.86,0,0,1,3-2.5,2.83,2.83,0,0,1,3,2.9c0,1.35-1,2.46-2.41,3.72l-7.52,6.43a.47.47,0,0,0-.17.37v2.93a.48.48,0,0,0,.49.49",
    style: {
      fill: "#fefefe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4,27.2c-3.17,0-6.16-1.57-6.46-5.39a.49.49,0,0,1,.49-.52h2.76a.49.49,0,0,1,.48.42,2.53,2.53,0,0,0,2.73,2.2,2.58,2.58,0,0,0,2.75-2.79,2.6,2.6,0,0,0-2.86-2.76h-.06a.47.47,0,0,1-.48-.47V15.66a.47.47,0,0,1,.48-.47h.06a2.34,2.34,0,0,0,2.57-2.54,2.5,2.5,0,0,0-5-.14v.13a.49.49,0,0,1-.49.48H82.63a.47.47,0,0,1-.48-.48v-.13C82.23,8.94,85,6.8,88.37,6.8c3.6,0,6.2,2.36,6.2,5.74a4.31,4.31,0,0,1-1.71,3.72.47.47,0,0,0,0,.77,4.79,4.79,0,0,1,2,4.18c0,4-3,6-6.46,6",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,18.74a.48.48,0,0,1,.23-.66A5.41,5.41,0,0,0,126.69,13c0-.06,0-.12,0-.18h0A5.83,5.83,0,0,0,125,8.52a6.27,6.27,0,0,0-4.64-1.72h-7.61a.48.48,0,0,0-.48.48v19.2a.48.48,0,0,0,.48.49h3a.48.48,0,0,0,.48-.49V19.4a.49.49,0,0,1,.48-.48h2a.49.49,0,0,1,.43.27l3.67,7.5a.48.48,0,0,0,.43.28h3.47a.48.48,0,0,0,.42-.71Zm-3.35-3.1h-3.71V10.79a.48.48,0,0,1,.47-.48h3.15a2.88,2.88,0,0,1,2,.7,2.78,2.78,0,0,1,.89,1.49,3.59,3.59,0,0,1,0,.47A2.63,2.63,0,0,1,119.9,15.64Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.06,12c-3.79,0-6.37,2.7-6.37,7.47,0,5.92,3.31,7.5,6.76,7.5A6.87,6.87,0,0,0,140.64,25a.5.5,0,0,0,0-.71l-1.53-1.49a.49.49,0,0,0-.66,0,3.93,3.93,0,0,1-3,1.07,3,3,0,0,1-3.17-2.73.49.49,0,0,1,.48-.53h8.15a.49.49,0,0,0,.49-.48V19c0-4-2.3-7-6.37-7m2.25,6.12h-4.5a.48.48,0,0,1-.48-.55,3.56,3.56,0,0,1,.29-1,2.72,2.72,0,0,1,4.88,0,3.91,3.91,0,0,1,.29,1,.49.49,0,0,1-.48.55",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,12.48H152.8a.33.33,0,0,0-.33.33v0a.33.33,0,0,1-.54.25A4.42,4.42,0,0,0,148.75,12a5.16,5.16,0,0,0-3.67,1.35c-1.44,1.44-1.55,3-1.55,5.72s.11,4.39,1.55,5.83a5.09,5.09,0,0,0,3.64,1.35,4.48,4.48,0,0,0,3.63-1.53v.82a2.9,2.9,0,0,1-3.07,3.18h-3.14a.48.48,0,0,0-.48.49v2.25a.47.47,0,0,0,.48.48h3.14c4.63,0,6.89-2.67,6.89-6.34V13a.49.49,0,0,0-.49-.49m-5.85,10.33c-2.26,0-2.49-1.71-2.49-3.74s.23-3.64,2.49-3.64,2.52,1.62,2.52,3.64-.26,3.74-2.52,3.74",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg123Reg);
export default __webpack_public_path__ + "static/media/123Reg.55d016511ca7ed3c4b66173608ce0b73.svg";
export { ForwardRef as ReactComponent };